import { IssueUpdateDataSupplier } from '@arpada/arp-lib-common-qupro';

export class EdicionMasivaModel {
    id: number;
    issueUpdateDataSupplier: IssueUpdateDataSupplier;
}
